import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex shrink-0 items-start justify-between gap-4 border-b border-slate-100 px-5 pb-4 pt-5"
};
const _hoisted_2 = ["disabled"];
const _hoisted_3 = {
  class: "min-h-0 flex-1 overflow-y-auto px-5 py-5"
};
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col items-center gap-3 rounded-lg border border-slate-200 bg-slate-50 px-4 py-10 text-center"
};
const _hoisted_5 = {
  class: "rounded-lg border border-slate-200 bg-white px-4 py-3"
};
const _hoisted_6 = {
  class: "form-switch"
};
const _hoisted_7 = {
  class: "mt-3 block"
};
const _hoisted_8 = ["disabled"];
const _hoisted_9 = {
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_10 = {
  class: "rounded-lg border border-slate-200 bg-white px-4 py-3"
};
const _hoisted_11 = {
  class: "form-switch"
};
const _hoisted_12 = {
  class: "mt-3 block"
};
const _hoisted_13 = ["disabled"];
const _hoisted_14 = {
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_15 = {
  class: "flex shrink-0 justify-end gap-2 border-t border-slate-100 bg-slate-50 px-5 py-4"
};
const _hoisted_16 = ["disabled"];
const _hoisted_17 = ["disabled"];
import { reactive, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { XMarkIcon } from '@heroicons/vue/24/outline';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'WorkReportReminderSettingModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    setting: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue', 'submit'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const form = reactive({
      planReminderEnabled: false,
      planReminderOffsetMinutes: -30,
      summaryReminderEnabled: false,
      summaryReminderOffsetMinutes: -20
    });
    watch(() => props.setting, setting => syncForm(setting), {
      immediate: true,
      deep: true
    });
    function syncForm(setting = {}) {
      form.planReminderEnabled = setting?.planReminderEnabled === true;
      form.planReminderOffsetMinutes = integerOrDefault(setting?.planReminderOffsetMinutes, -30);
      form.summaryReminderEnabled = setting?.summaryReminderEnabled === true;
      form.summaryReminderOffsetMinutes = integerOrDefault(setting?.summaryReminderOffsetMinutes, -20);
    }
    function close() {
      if (!props.saving) emit('update:modelValue', false);
    }
    function submit() {
      if (props.loading || props.saving) return;
      if (form.planReminderEnabled && !Number.isInteger(Number(form.planReminderOffsetMinutes))) {
        ElMessage.warning('请填写有效的计划提醒时间');
        return;
      }
      if (form.summaryReminderEnabled && !Number.isInteger(Number(form.summaryReminderOffsetMinutes))) {
        ElMessage.warning('请填写有效的总结提醒时间');
        return;
      }
      emit('submit', {
        planReminderEnabled: form.planReminderEnabled,
        planReminderOffsetMinutes: form.planReminderEnabled ? Number(form.planReminderOffsetMinutes) : null,
        summaryReminderEnabled: form.summaryReminderEnabled,
        summaryReminderOffsetMinutes: form.summaryReminderEnabled ? Number(form.summaryReminderOffsetMinutes) : null
      });
    }
    function reminderOffsetLabel(enabled, offset) {
      if (!enabled) return '未开启';
      const value = Number(offset);
      if (!Number.isFinite(value)) return '已开启';
      if (value === 0) return '截止时';
      return value < 0 ? `截止前 ${Math.abs(value)} 分钟` : `截止后 ${value} 分钟`;
    }
    function integerOrDefault(value, fallback) {
      if (value === null || value === undefined || value === '') return fallback;
      const number = Number(value);
      return Number.isInteger(number) ? number : fallback;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.modelValue,
        size: "lg",
        "panel-class": "max-h-[86vh]",
        "z-index": 75,
        scrollable: false,
        onClose: close
      }, {
        default: _withCtx(() => [_createElementVNode("header", _hoisted_1, [_cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "min-w-0"
        }, [_createElementVNode("h2", {
          class: "text-base font-semibold text-slate-900"
        }, "提醒设置"), _createElementVNode("p", {
          class: "mt-1 text-sm leading-6 text-slate-500"
        }, "设置你自己的计划与总结提醒时间。")], -1)), _createElementVNode("button", {
          type: "button",
          class: "rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600",
          title: "关闭提醒设置",
          "aria-label": "关闭提醒设置",
          disabled: __props.saving,
          onClick: close
        }, [_createVNode(_unref(XMarkIcon), {
          class: "h-5 w-5"
        })], 8, _hoisted_2)]), _createElementVNode("div", _hoisted_3, [__props.loading ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[5] || (_cache[5] = [_createElementVNode("div", {
          class: "app-spinner"
        }, null, -1), _createElementVNode("span", {
          class: "text-sm text-slate-500"
        }, "正在加载提醒设置...", -1)]))])) : (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "space-y-4",
          onSubmit: _withModifiers(submit, ["prevent"])
        }, [_createElementVNode("section", _hoisted_5, [_createElementVNode("label", _hoisted_6, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.planReminderEnabled = $event),
          class: "form-switch-input",
          type: "checkbox"
        }, null, 512), [[_vModelCheckbox, form.planReminderEnabled]]), _cache[6] || (_cache[6] = _createElementVNode("span", {
          class: "form-switch-track"
        }, null, -1)), _cache[7] || (_cache[7] = _createElementVNode("span", {
          class: "form-switch-label"
        }, "计划提交提醒", -1))]), _createElementVNode("label", _hoisted_7, [_cache[8] || (_cache[8] = _createElementVNode("span", {
          class: "form-label"
        }, "相对计划截止（分钟）", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.planReminderOffsetMinutes = $event),
          class: "form-input mt-1 w-full",
          type: "number",
          disabled: !form.planReminderEnabled
        }, null, 8, _hoisted_8), [[_vModelText, form.planReminderOffsetMinutes, void 0, {
          number: true
        }]])]), _createElementVNode("p", _hoisted_9, _toDisplayString(reminderOffsetLabel(form.planReminderEnabled, form.planReminderOffsetMinutes)), 1)]), _createElementVNode("section", _hoisted_10, [_createElementVNode("label", _hoisted_11, [_withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.summaryReminderEnabled = $event),
          class: "form-switch-input",
          type: "checkbox"
        }, null, 512), [[_vModelCheckbox, form.summaryReminderEnabled]]), _cache[9] || (_cache[9] = _createElementVNode("span", {
          class: "form-switch-track"
        }, null, -1)), _cache[10] || (_cache[10] = _createElementVNode("span", {
          class: "form-switch-label"
        }, "总结提交提醒", -1))]), _createElementVNode("label", _hoisted_12, [_cache[11] || (_cache[11] = _createElementVNode("span", {
          class: "form-label"
        }, "相对总结截止（分钟）", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.summaryReminderOffsetMinutes = $event),
          class: "form-input mt-1 w-full",
          type: "number",
          disabled: !form.summaryReminderEnabled
        }, null, 8, _hoisted_13), [[_vModelText, form.summaryReminderOffsetMinutes, void 0, {
          number: true
        }]])]), _createElementVNode("p", _hoisted_14, _toDisplayString(reminderOffsetLabel(form.summaryReminderEnabled, form.summaryReminderOffsetMinutes)), 1)]), _cache[12] || (_cache[12] = _createElementVNode("p", {
          class: "rounded-lg border border-blue-100 bg-blue-50 px-3 py-2 text-xs leading-5 text-blue-700"
        }, " 负数表示截止前提醒，0 表示截止时提醒，正数表示截止后提醒。 ", -1))], 32))]), _createElementVNode("footer", _hoisted_15, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          disabled: __props.saving,
          onClick: close
        }, "取消", 8, _hoisted_16), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          disabled: __props.loading || __props.saving,
          onClick: submit
        }, _toDisplayString(__props.saving ? '保存中' : '保存设置'), 9, _hoisted_17)])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};